import React, { useMemo, useState, useEffect } from "react"
import he from "he";
import "./WhyWorkWithAkinex.css";
import { fixImagePaths } from "../util";
import { useSelector } from "react-redux";


const WhyWorkWithAkinex = () => {
  const [whyWorkWithAkinex, setWhyWorkWithAkinex] = useState("");
  const { page } = useSelector((state) => state.data);

    useEffect(() => {
      if (page?.statusCode === 200 && page?.data?.why_work_with_akinex_section) {
        setWhyWorkWithAkinex(he.decode(page.data.why_work_with_akinex_section.htmlContent));
      }
    }, [page]);

  const processedContent = useMemo(() => fixImagePaths(whyWorkWithAkinex), [whyWorkWithAkinex]);
  
    return (
      <div>
        {processedContent && (
          <div className="whyWorkWithAkinex adminContentParaRemoval" dangerouslySetInnerHTML={{ __html: processedContent }} />
        )}
      </div>
    );
  };
  

export default WhyWorkWithAkinex;